import { connect } from 'react-redux';
import { forgotPassword } from './../../../actions/auth';
import Component from './RestorePassword';

export default connect(
  undefined,
  //Dispatches
  (dispatch) => ({
    forgotPassword: (email) => dispatch(forgotPassword(email))
  })
)(Component);



// WEBPACK FOOTER //
// ./src/components/auth/RestorePassword/index.js